/**
 * Created by Mikhail Menshenin on 03.07.2024
 */

class CoinKingdomSceneComponent extends ScriptComponent {
    onAttach() {
        this.slotMachine = aisensia.slotMachine;

        this.backgroundBundle = this.getBackgroundBundle();

        const gameSceneComponent = ComponentMap.get(this.node, GameSceneComponent);
        gameSceneComponent.styling = this.getBackgroundStyles();

        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(gameSceneComponent.styling);
        this.sceneComponent.setBundles(gameSceneComponent.listBundles().concat(["transition_attack", "transition_raid"]));
    }

    onSceneLoaded() {
        const styles = cleverapps.styles.CoinKingdomScene;

        const slotMachineView = this.slotMachineView = new CoinSlotMachineView(this.slotMachine);
        slotMachineView.setAnchorPoint(0.5, 0);
        slotMachineView.setScale2(styles.slotmachine.scale);
        VillageSceneComponent.AddControl(this.node, slotMachineView, {
            direction: HidingComponent.DIR.NONE,
            control: "slotMachine"
        }, styles.slotmachine.position);

        this.clouds = [];
        this.addClouds("clouds2_png", styles.clouds2.position);

        const button = this.button = new CoinSlotMachineButtonView(this.slotMachine);
        button.setAnchorPoint(0.5, 0);
        VillageSceneComponent.AddControl(this.node, button, {
            direction: HidingComponent.DIR.NONE,
            control: "button"
        }, styles.button.position);

        this.addClouds("clouds3_png", styles.clouds3.position);

        VillageSceneComponent.AddControl(this.node, new ShieldsView(), {
            direction: cleverapps.UI.VERTICAL,
            control: "shields"
        }, styles.shields);

        if (this.slotMachine.isBeforeFirstSpin()) {
            this.forceSpin();
        }
    }

    addClouds(frameId, position) {
        const sprites = cleverapps.rangeArray(0, 2).map(() => {
            const sprite = new cc.Sprite(bundles[this.backgroundBundle].frames[frameId]);
            sprite.frameId = frameId;
            cleverapps.UI.fitToBox(sprite, cleverapps.resolution.getSceneSize());
            return sprite;
        });
        this.clouds.push(...sprites);

        const clouds = new cleverapps.Layout(sprites, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: 0,
            padding: 0
        });
        clouds.setAnchorPoint(0.5, 1);
        clouds.setAlignment(position);
        this.node.addChild(clouds);
    }

    forceSpin() {
        const buttonHitPoint = new cc.Node();
        buttonHitPoint.setAlignment(cleverapps.styles.CoinKingdomScene.hit);
        this.button.addChild(buttonHitPoint);

        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "firstSpinForce",
            control: ["slotMachine", "button"],
            action: (f) => {
                cleverapps.forces.create(buttonHitPoint, {
                    text: "Tutorial.SlotMachine.FirstSpinForce"
                }, {
                    actives: [this.slotMachineView.payline, this.button]
                });
                cleverapps.forces.onceForceClosed = f;
            }
        });
    }

    onResize() {
        const backgroundBundle = this.getBackgroundBundle();
        if (!this.clouds || backgroundBundle === this.backgroundBundle) {
            return;
        }

        cleverapps.bundleLoader.loadBundles([backgroundBundle], {
            onSuccess: () => {
                this.backgroundBundle = backgroundBundle;

                if (this.node.background) {
                    this.node.background.removeFromParent();
                }
                this.sceneComponent.setStyling(this.getBackgroundStyles());
                this.sceneComponent.setBackground();

                this.clouds.forEach((sprite) => {
                    sprite.setSpriteFrame(bundles[backgroundBundle].frames[sprite.frameId]);
                    cleverapps.UI.fitToBox(sprite, cleverapps.resolution.getSceneSize());
                });
            }
        });
    }

    onDestruct() {
        this.slotMachine.purge();
    }

    getBackgroundBundle() {
        return cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? "game_background_vertical" : "game_background_horizontal";
    }

    getBackgroundStyles() {
        return {
            bundle: this.backgroundBundle,
            backgroundId: "background"
        };
    }
}

Prefab.registerComponent("CoinKingdomSceneComponent", CoinKingdomSceneComponent);

GameScene = bundles.main.jsons.coinkingdomscene_prefab_json;

cleverapps.styles.CoinKingdomScene = {
    slotmachine: {
        scale: [0.87, 1, 1],
        position: [{
            x: { align: "center" },
            y: { align: "bottom", dy: -130 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: -209 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: -209 }
        }]
    },

    button: {
        position: [{
            x: { align: "center" },
            y: { align: "bottom", dy: 0 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 21 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 21 }
        }]
    },

    shields: [{
        x: { align: "right", dx: -110 },
        y: { align: "top", dy: -12 }
    }, {
        x: { align: "right", dx: -150 },
        y: { align: "top", dy: -12 }
    }, {
        x: { align: "right", dx: -150 },
        y: { align: "top", dy: -12 }
    }],

    hit: {
        x: { align: "center" },
        y: { align: "center", dy: 100 }
    },

    clouds2: {
        position: [{
            x: { align: "center" },
            y: { align: "bottom", dy: 150 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 60 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 60 }
        }]
    },

    clouds3: {
        position: [{
            x: { align: "center" },
            y: { align: "bottom", dy: 20 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 36 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: 36 }
        }]
    }
};
